// extracted by mini-css-extract-plugin
module.exports = {"venues":"ProximityVenue-module--venues--5855ac"};